module.exports = __webpack_public_path__ + "static/media/1.72efbcf3.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/89gal/1.JPG
// module id = 225
// module chunks = 0